import { j as t } from "../../../../node_modules/react/jsx-runtime.js";
import l from "../../Button/Button.js";
import { Typography as f } from "../../Typography/Typography.js";
import x from "../Calender.module.scss.js";
import { clsx as i } from "../../../../node_modules/clsx/dist/clsx.m.js";
import { formatDate as a } from "../../../../utils/helper.js";
import { i18n as p } from "../../../../utils/locale/locale.js";
import { DEFAULT_DATE_FORMAT as m } from "../calender.helper.js";
const A = ({
  type: e,
  starRangeDate: r,
  endRangeDate: o,
  onChange: n,
  showTodayButton: c,
  size: s,
  disabledTodayButton: d
}) => {
  const u = /* @__PURE__ */ new Date();
  return /* @__PURE__ */ t.jsxs("div", { className: x.selectedDates, children: [
    /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: i("flex items-center gap-100", {
          "justify-between w-full": s === "compact"
        }),
        children: [
          r && /* @__PURE__ */ t.jsx(
            "div",
            {
              className: i({
                "flex-1": e === "single" && s === "compact"
              }),
              children: /* @__PURE__ */ t.jsx(
                l,
                {
                  variant: "outlined",
                  color: "neutral",
                  size: "medium",
                  label: r ? a(r, m) : "",
                  fullWidth: !0,
                  styles: { justifyContent: "start" }
                }
              )
            }
          ),
          e === "range" && o && /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
            /* @__PURE__ */ t.jsx(
              f,
              {
                text: "–",
                textColor: "color/fg/lighter",
                variant: "interface/medium/sm"
              }
            ),
            /* @__PURE__ */ t.jsx(
              l,
              {
                variant: "outlined",
                color: "neutral",
                size: "medium",
                label: o ? a(o, m) : ""
              }
            )
          ] })
        ]
      }
    ),
    c && e !== "range" && /* @__PURE__ */ t.jsx(
      l,
      {
        testId: "calender-today-button",
        variant: "outlined",
        color: "neutral",
        disabled: d,
        label: p("today"),
        onClick: () => n(u)
      }
    )
  ] });
};
export {
  A as default
};
//# sourceMappingURL=SelectedDates.js.map
